export const AUTH_ROLES = {
  UM_ADMINISTRATOR: 'UM_ADMINISTRATOR',
  UM_SAC: 'UM_SAC',
  UM_OPERATOR: 'UM_OPERATOR',
};

export const AUTH_PERMISSIONS = {
  ADD_NEW_USER: 'ADD_NEW_USER',
  EDIT_USER_ROLES: 'EDIT_USER_ROLES',
  MANAGE_USER_ACCESS: 'MANAGE_USER_ACCESS',
  RESET_USER_PASSWORD: 'RESET_USER_PASSWORD',
  DELETE_USER: 'DELETE_USER',
};

export const JWT_CUSTOM_ATTRIBUTES = {
  GROUP: 'custom:group',
  TENANT_ID: 'custom:tenantId',
};
